export enum START_DATE {
  ID = "startAt",
  TITLE = "Start Date",
}

export enum END_DATE {
  ID = "endAt",
  TITLE = "End Date",
}

export enum AUDIENCE {
  ID = "audience",
  TITLE = "Audience",
}
